<template>
	<div class="mb-4 rounded-4 bg-white box-shadow-main border-form">
    <div 
      @click="onBack('room_type_detail', data);onBack('handlePopupFilter', 'detail-room');$postLog('SEARCH','','Clicked Room Type Detail');hitGoogleAnalytics('room_detail')"
      class="sticky bg-white border-bottom rounded-4 wrapper-position" 
      :class="{'old':header_scroll, 'new' : designType === 'NEW'}">
      <div class="position-relative">
        <!-- ROOM TYPE IMAGE -->
        <template v-if="data.image.length > 0">
          <flickity ref="flickity" class="room-detail h-img-nearby text-center" :options="flickityOptionsRoom">
            <div class="carousel-cell w-100" v-for="image in data.image">
              <div class="h-img-nearby">
                <img :src="image.image_url" class="object-fit w-100 h-img-nearby">
              </div>
            </div>
          </flickity>

          <div v-if="false" class="slider-action-btn prev" @click="slideTheSlider('prev')">
            <svg class="transform-180" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="11" cy="11" r="10.5" transform="rotate(-180 11 11)" fill="white" stroke="#D9D9D9"/>
              <path d="M13.4816 10.9821C13.4816 10.8609 13.4332 10.7398 13.3411 10.6574L9.49798 6.90636C9.41559 6.82398 9.30897 6.77551 9.18782 6.77551C8.93581 6.77551 8.74196 6.96454 8.74196 7.21652C8.74196 7.33769 8.79042 7.44914 8.86796 7.53156L12.6626 11.2438V10.7252L8.86796 14.4375C8.79042 14.515 8.74196 14.6265 8.74196 14.7525C8.74196 15.0045 8.93581 15.1935 9.18782 15.1935C9.30897 15.1935 9.41559 15.145 9.50283 15.0626L13.3411 11.3116C13.4332 11.2196 13.4816 11.1081 13.4816 10.9821Z" fill="black" fill-opacity="0.85"/>
            </svg>
          </div>
          <div v-if="false" class="slider-action-btn next" @click="slideTheSlider('next')">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="11" cy="11" r="10.5" transform="rotate(-180 11 11)" fill="white" stroke="#D9D9D9"/>
              <path d="M13.4816 10.9821C13.4816 10.8609 13.4332 10.7398 13.3411 10.6574L9.49798 6.90636C9.41559 6.82398 9.30897 6.77551 9.18782 6.77551C8.93581 6.77551 8.74196 6.96454 8.74196 7.21652C8.74196 7.33769 8.79042 7.44914 8.86796 7.53156L12.6626 11.2438V10.7252L8.86796 14.4375C8.79042 14.515 8.74196 14.6265 8.74196 14.7525C8.74196 15.0045 8.93581 15.1935 9.18782 15.1935C9.30897 15.1935 9.41559 15.145 9.50283 15.0626L13.3411 11.3116C13.4332 11.2196 13.4816 11.1081 13.4816 10.9821Z" fill="black" fill-opacity="0.85"/>
            </svg>
          </div>
        </template>
        <div class="h-img-nearby" v-else>
          <img src="../../../../assets/img/icon/hotel-placeholder.svg" class="object-fit w-100 h-img-nearby">
        </div>

        <!-- SHARE LINK -->
        <div :id="data.id" class="position-absolute cursor-pointer" style="right: 10px;bottom: 10px;" @click="$copyText(room_type_url,'Room URL copied!')">
          <img src="../../../../assets/img/icon/share-outline-white.svg" width="30">
        </div>
        <b-tooltip :target="data.id" placement="right" :title="`Share ${$t('hotel.unit-type.'+data.type+'.unit')} via url`">
        </b-tooltip>
      </div>

      <!-- ROOM TYPE DATA -->
      <div class="bg-white px-3 rounded-4 py-2">
        <div class="p-1">
          <p class="mb-1 body-2-2 font-bold text-18 d-block">{{data.name}}</p>
          
          <div class="d-flex flex-wrap align-items-center mb-2">
            <div v-if="$isNotEmptyV3(data.room_size)" class="mb-2 d-flex align-items-center mr-2-5">
              <svg class="mr-1 flex-0" height="12" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.67969 21.5977H17.8945C20.3555 21.5977 21.5742 20.3789 21.5742 17.9648V3.65625C21.5742 1.24219 20.3555 0.0234375 17.8945 0.0234375H3.67969C1.23047 0.0234375 0 1.23047 0 3.65625V17.9648C0 20.3906 1.23047 21.5977 3.67969 21.5977ZM3.70312 19.7109C2.53125 19.7109 1.88672 19.0898 1.88672 17.8711V3.75C1.88672 2.53125 2.53125 1.91016 3.70312 1.91016H17.8711C19.0312 1.91016 19.6875 2.53125 19.6875 3.75V17.8711C19.6875 19.0898 19.0312 19.7109 17.8711 19.7109H3.70312Z" fill="#222"/>
                <path d="M15.8555 10.7812C16.3125 10.7812 16.6875 10.418 16.6875 9.96094V5.88281C16.6875 5.17969 16.3242 4.91016 15.7148 4.91016H11.6602C11.2031 4.91016 10.8281 5.28516 10.8281 5.74219C10.8281 6.19922 11.2031 6.5625 11.6602 6.5625H12.2344L14.0273 6.44531L11.3789 8.96484C11.0391 9.29297 11.0273 9.86719 11.3672 10.207C11.7188 10.5586 12.2695 10.5703 12.6211 10.1953L15.1523 7.53516L15.0352 9.38672V9.96094C15.0352 10.418 15.3984 10.7812 15.8555 10.7812ZM9.9375 16.6992C10.3945 16.6992 10.7578 16.3242 10.7578 15.8672C10.7578 15.4102 10.3945 15.0469 9.9375 15.0469H9.36328L7.57031 15.1641L10.207 12.6445C10.5469 12.3164 10.5586 11.7422 10.2188 11.4023C9.87891 11.0508 9.31641 11.0391 8.97656 11.4141L6.44531 14.0742L6.5625 12.2227V11.6484C6.5625 11.1914 6.1875 10.8281 5.73047 10.8281C5.27344 10.8281 4.91016 11.1914 4.91016 11.6484V15.7266C4.91016 16.4297 5.26172 16.6992 5.87109 16.6992H9.9375Z" fill="#222"/>
              </svg>
              <p class="mb-0 body-3-1 lh-1">{{data.room_size}} m²</p>
            </div>
            
            <div v-if="$isNotEmptyV3(data.max_guests)" class="mb-2 d-flex align-items-center mr-2-5">
              <svg class="mr-1 flex-0" height="12" viewBox="0 0 35 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1157_49)">
                  <path
                    d="M8.90625 12.5391C11.3203 12.5391 13.3008 10.3711 13.3008 7.71094C13.3008 5.10938 11.3438 3.01172 8.90625 3.01172C6.49219 3.01172 4.51172 5.14453 4.51172 7.73438C4.51172 10.3828 6.49219 12.5391 8.90625 12.5391ZM8.90625 10.793C7.47656 10.793 6.25781 9.42188 6.25781 7.73438C6.25781 6.08203 7.46484 4.75781 8.90625 4.75781C10.3828 4.75781 11.5664 6.05859 11.5664 7.71094C11.5664 9.42188 10.3477 10.793 8.90625 10.793ZM2.39062 23.2852H15.4102C17.0039 23.2852 17.7891 22.6406 17.7891 21.3281C17.7891 17.4375 13.8164 13.875 8.89453 13.875C3.98438 13.875 0 17.4375 0 21.3281C0 22.6406 0.796875 23.2852 2.39062 23.2852ZM2.09766 21.5508C1.86328 21.5508 1.74609 21.457 1.74609 21.2227C1.74609 18.3164 5.0625 15.6094 8.89453 15.6094C12.7383 15.6094 16.043 18.3164 16.043 21.2227C16.043 21.457 15.9375 21.5508 15.7031 21.5508H2.09766Z"
                    fill="#222" />
                  <path
                    d="M15.0469 24.8789H29.7656C32.8828 24.8789 34.2422 23.4023 34.2422 21.4102C34.2422 17.4258 29.625 12.293 22.4062 12.293C15.1758 12.293 10.5703 17.4258 10.5703 21.4102C10.5703 23.4023 11.918 24.8789 15.0469 24.8789ZM22.4062 12.4336C25.1953 12.4336 27.4688 9.96094 27.4688 6.9375C27.4688 3.9375 25.207 1.58203 22.4062 1.58203C19.6289 1.58203 17.3438 3.98438 17.3438 6.96094C17.3438 9.97266 19.6289 12.4336 22.4062 12.4336Z"
                    fill="white" />
                  <path
                    d="M22.4062 12.4336C25.1953 12.4336 27.4688 9.96094 27.4688 6.9375C27.4688 3.9375 25.207 1.58203 22.4062 1.58203C19.6289 1.58203 17.3438 3.98438 17.3438 6.96094C17.3438 9.97266 19.6289 12.4336 22.4062 12.4336ZM22.4062 10.6641C20.6953 10.6641 19.2305 9.03516 19.2305 6.96094C19.2305 4.92188 20.6719 3.35156 22.4062 3.35156C24.1523 3.35156 25.582 4.88672 25.582 6.9375C25.582 9.01172 24.1406 10.6641 22.4062 10.6641ZM15.0469 23.2852H29.7656C31.7109 23.2852 32.6367 22.6992 32.6367 21.4102C32.6367 18.3398 28.7578 13.8984 22.4062 13.8984C16.043 13.8984 12.1641 18.3398 12.1641 21.4102C12.1641 22.6992 13.0898 23.2852 15.0469 23.2852ZM14.4844 21.5156C14.1797 21.5156 14.0508 21.4336 14.0508 21.1875C14.0508 19.2539 17.0273 15.668 22.4062 15.668C27.7734 15.668 30.75 19.2539 30.75 21.1875C30.75 21.4336 30.6328 21.5156 30.3281 21.5156H14.4844Z"
                    fill="#222" />
                </g>
                <defs>
                  <clipPath id="clip0_1157_49">
                    <rect width="34.2422" height="24.8789" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <p class="mb-0 body-3-1 lh-1">Max {{data.max_guests}} {{$pluralWord(type.max_guests,'guest')}}</p>
            </div>

            <div v-if="$isNotEmptyV3(data.bed)" class="mb-2 d-flex align-items-center">
              <svg class="mr-1 flex-0" height="12" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.90586 17.9786H1.54529C2.08881 17.9786 2.45115 17.627 2.45115 17.0728V15.4956C2.56838 15.5275 2.92007 15.5489 3.17584 15.5489H23.8294C24.0852 15.5489 24.4369 15.5275 24.5541 15.4956V17.0728C24.5541 17.627 24.9164 17.9786 25.46 17.9786H26.0994C26.6536 17.9786 27.0053 17.627 27.0053 17.0728V9.77264C27.0053 7.73711 25.897 6.63942 23.8614 6.63942H3.14387C1.10835 6.63942 0 7.73711 0 9.77264V17.0728C0 17.627 0.351687 17.9786 0.90586 17.9786ZM2.13144 13.9929C1.90764 13.9929 1.76909 13.833 1.76909 13.5773V9.52755C1.76909 8.71757 2.30195 8.19537 3.13321 8.19537H23.8827C24.7034 8.19537 25.2362 8.71757 25.2362 9.52755V13.5773C25.2362 13.833 25.0977 13.9929 24.8739 13.9929H2.13144ZM2.77087 6.86323H5.57371V4.66784C5.57371 3.67673 6.12788 3.13321 7.14031 3.13321H10.8809C11.8827 3.13321 12.4369 3.67673 12.4369 4.66784V6.86323H14.5683V4.66784C14.5683 3.67673 15.1225 3.13321 16.1243 3.13321H19.865C20.8774 3.13321 21.4316 3.67673 21.4316 4.66784V6.86323H24.2344V2.98401C24.2344 1.01243 23.1794 0 21.2611 0H5.74422C3.83658 0 2.77087 1.01243 2.77087 2.98401V6.86323Z" fill="#222"/>
              </svg>
              <p class="mb-0 body-3-1 lh-1">
                <template v-for="(bed, index) in data.bed">
                  {{bed.qty}} {{bed.name}}
                  <span v-if="index + 1 < data.bed.length">, </span>
                </template>
              </p>
            </div>
          </div>

          <!-- Facility -->
          <div class="d-flex flex-wrap align-items-center" v-if="$isNotEmptyV2(facilityHighlight)">
            <div v-for="facility in facilityHighlight" class="mb-2 d-flex align-items-center mr-2-5">
              <div class="mr-1 flex-0 lh-1">
                <img :src="facility.icon" height="12" style="vertical-align: baseline !important;">
              </div>
              <p class="mb-0 body-3-1 lh-1 text-black">
                {{facility.name}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 8px;"></div>
    <!-- ROOM RATE LIST -->
    <div class="mb-1 position-relative bg-white" style="top:-10px">
      <div 
        class="px-3 bg-white position-relative" 
        :class="{
          'z-index-1042 rounded-4 position-relative':selected_room_rate.id == room_rate.id && type =='room_rate_add',
          'border-2-green rounded-4 mt-1': checkRoomRateDetailInline(index,room_rate)
        }" v-for="(room_rate,index) in data.room_rate.slice(0, length_more)">

        <div class="px-3 py-2 bg-green position-absolute" style="top:0px;right:0px;border-radius: 0px 0px 0px 4px;" v-if="checkRoomRateDetailInline(index,room_rate)">
          <p class="mb-0 body-3-3-2 text-white">{{getBeSortBy()=='room_type'?'LOWEST PRICE':getBeSortBy()=='promotion'?'BIGGEST DISCOUNT':'BEST DEAL'}}</p>
        </div>

        <div class="row no-gutters py-3 border-top">
          <!-- GENERAL INFORMATION -->
          <div class="col-12 mb-1">

            <!-- ROOM RATE NAME -->
            <p class="mb-0 body-2-2 font-bold text-16 d-block" :class="{'w-65':checkRoomRateDetailInline(index,room_rate)}">{{room_rate.name}}</p>

            <!-- PROMOTION -->
            <div v-if="room_rate.bookable && $roomAvbl(room_rate.room_type.id,data.id) > 0" class="d-flex align-items-center mt-1">
              <div>
                <template v-if="room_rate.best_price.promotion_price < 0 && $roomAvbl(room_rate.room_type.id,room_rate.id) > 0">
                  <div class="py-1 px-2 border-orange lh-1 rounded-4 d-table" v-if="promotionCounter(room_rate.dates) != ''">
                    <p class="mb-0 body-3-3-2 text-orange">{{promotionCounter(room_rate.dates)}}</p>
                  </div>
                </template>
              </div>
              <div class="ml-2" v-if="$showDiscountMembership(room_rate.dates)">
                <div class="py-1 px-2 border-orange lh-1 rounded-4 d-table">
                  <p class="mb-0 body-3-3-2 text-orange">Exclusive Member Price</p>
                </div>
              </div>
            </div>

            <!-- HIGHTLIGHT -->
            <ul class="pl-3 mt-2" :class="getMerchant().search_room_is_show_room_rate_detail ? 'mb-0' : 'mb-3'">
              <li><p class="mb-0 body-2-2">{{room_rate.minimum_deposit_value > 0 ? 'Prepayment is required' : 'No Prepayment required'}}</p></li>
              <li><p class="mb-0 body-2-2">{{room_rate.cancellation_policy.title}}</p></li>
              <li><p class="mb-0 body-2-2" :class="room_rate.rate.is_included_breakfast?'text-success':'text-danger'">{{room_rate.rate.is_included_breakfast?'Breakfast Included':'No meal included'}}</p></li>
            </ul>

            <!-- MORE DATA -->
            <template v-if="!getMerchant().search_room_is_show_room_rate_detail && checkRoomRateDetailInline(index,room_rate) && (($isNotEmpty(room_rate.description_room_rate) || $isNotEmpty(room_rate.description_promotion)) || room_rate.rate.inclusion.length > 0)">
              <div class="border-top border-bottom py-3 mb-3">

                <!-- DESCRIPTION -->
                <div class="mb-3"v-if="$isNotEmpty(room_rate.description_room_rate) || $isNotEmpty(room_rate.description_promotion)">
                  <p class="mb-1 body-3-3 text-14 font-semibold">{{$t('general.description')}}</p>
                  <p v-if="$isNotEmpty(room_rate.description_room_rate)" class="mb-0 body-3-3 font-regular" v-html="$convertNewlinesToBr(room_rate.description_room_rate)"></p>
                  <span v-if="$isNotEmpty(room_rate.description_room_rate) && $isNotEmpty(room_rate.description_promotion)" class="my-2 w-100 d-block"></span>
                  <p v-if="$isNotEmpty(room_rate.description_promotion)" class="mb-0 body-3-3 font-regular" v-html="$convertNewlinesToBr(room_rate.description_promotion)"></p>
                </div>
                
                <template v-if="room_rate.rate.inclusion.length > 0">
                  <p class="mb-1 body-3-3 text-14 font-semibold">{{$t('hotel.room-type.include-in-rate')}}</p>
                  <ul class="pl-3">
                    <li :class="{
                      'mb-2' : index + 1 < room_rate.rate.inclusion.length
                    }" v-for="(inclusion, index) in room_rate.rate.inclusion">
                      <span class="body-3-3 d-block">{{inclusion.inclusion_item.name}}</span>
                      <span class="body-3-3-1 restrict-p-mb html-desc" v-html="inclusion.inclusion_item.description"></span>
                    </li>
                  </ul>
                </template>
              </div>
            </template>
          </div>
          <div v-if="getMerchant().search_room_is_show_room_rate_detail" class="col-12 mb-1">
            <roomRateDetailInline
              :show-as-popup="false"
              :data="room_rate"></roomRateDetailInline>
          </div>

          <!-- PRICE DETAIL -->
          <div class="col-12 mb-1">
            <div class="row no-gutters">
              <div :class="room_rate.bookable && $roomAvbl(room_rate.room_type.id,room_rate.id) > 0 ? 'col-7' : 'col-5'">
                <template v-if="room_rate.bookable && $roomAvbl(room_rate.room_type.id,room_rate.id) > 0">
                	<div v-if="checkDiscount(room_rate.dates)">
                    <!-- PROMO COUNTDOWN -->
                    <div class="w-100" v-if="promotionTimeChecker(room_rate.dates)">
                      <p class="body-2-2 text-14 mb-0">Promo ends in <span class="mb-0 px-1 bg-orange mr-1 text-white radius-0 font-bold">{{promo_left.h}}</span>:<span class="mb-0 px-1 bg-orange ml-1 text-white radius-0 font-bold">{{promo_left.m}}</span></p>
                    </div>

                    <div class="w-100">
                      <!-- BASE PRICE -->
                      <p class="mb-0 text-subcolor text-14 font-lato-regular text-line-through-lato d-inline-block mr-2">{{$formatCurrency(getTotalPriceFromDate(room_rate.dates,'price')+getTotalPriceFromDate(room_rate.dates,'extra_guest_price'))}}</p>

                      <!-- PROMOTION PERCENT -->
                      <p class="mb-0 font-lato text-orange text-12 d-inline-block" v-if="percentCounter(getTotalPriceFromDate(room_rate.dates,'final_price',true), (getTotalPriceFromDate(room_rate.dates,'price')+getTotalPriceFromDate(room_rate.dates,'extra_guest_price'))) < 1">1% OFF</p>
                      <p class="mb-0 font-lato text-orange text-12 d-inline-block" v-else>{{percentCounter(getTotalPriceFromDate(room_rate.dates,'final_price',true), (getTotalPriceFromDate(room_rate.dates,'price')+getTotalPriceFromDate(room_rate.dates,'extra_guest_price')))}}% OFF</p>
                    </div>
                	</div>
                  <!-- FINAL PRICE -->
              		<p class="mb-1 font-lato text-20 text-orange d-inline-block">{{$formatCurrency(getTotalPriceFromDate(room_rate.dates,'final_price',true))}}</p>

                  <div class="d-block">
                    <p class="mb-1 body-3-1 lh-1 d-block">{{ printTotalNight(room_rate.dates) }}</p>
                    <p v-if="getMerchant().search_room_is_show_tax_fee_note" class="mb-0 body-3-1 text-green lh-1 d-block">(Includes taxes & fees)</p>
                  </div>
                </template>
              </div>
              <div class="text-right position-relative" :class="room_rate.bookable && $roomAvbl(room_rate.room_type.id,room_rate.id) > 0 ? 'col-5' : 'col-7'">
                <div class="text-right">
                  <div class="w-100" v-if="room_rate.bookable && showRoomLeft(room_rate.room_type.id,data.id)">
                    <p class="mb-0 body-3-3-2 text-danger"> 
                      {{printRoomLeft($roomAvbl(room_rate.room_type.id,room_rate.id))}}
                    </p>
                  </div>
                  <div class="position-relative mb-2" style="bottom: 0">
                    <template v-if="room_rate.bookable">
                      <template v-if="getQty(room_rate.id) != 0">
                        <button 
                          v-if="room_rate.room_type.is_virtual"
                          type="button" 
                          class="button-secondary bg-white text-orange px-3 py-2 mt-2 text-12">
                            Selected
                        </button>
                        <button v-else type="button" class="button-secondary bg-white text-orange px-3 py-2 mt-2 text-10" 
                        :class="{'position-relative z-index-1042':selected_room_rate.id == room_rate.id && type =='room_rate_add'}" 
                        @click="onBack('room_rate_add',room_rate)" >{{getQty(room_rate.id)}} 
                        <span v-if="getQty(room_rate.id) > 1">{{$t('hotel.unit-type.'+data.type+'.units')}} </span> 
                        <span v-else>{{$t('hotel.unit-type.'+data.type+'.unit')}} </span> 
                        <i class="simple-icon-arrow-up position-relative" v-if="selected_room_rate.id == room_rate.id && type =='room_rate_add'" style="top: 2px;"></i><i class="simple-icon-arrow-down position-relative" v-else style="top: 2px;"></i>
                        </button>
                      </template>
                      <template v-else>
                        <template v-if="$roomAvbl(room_rate.room_type.id,room_rate.id) > 0">
                          <button 
                            v-if="room_rate.room_type.is_virtual" 
                            type="button" 
                            class="button-secondary px-3 py-2 mt-2 text-10" 
                            :class="{'position-relative z-index-1042':selected_room_rate.id == room_rate.id && type =='room_rate_add'}" 
                            @click="addRoomRate(1,room_rate)" 
                            >{{$t('hotel.book-now')}}
                          </button>
                          <button 
                            v-else 
                            type="button" 
                            class="button-secondary px-3 py-2 mt-2 text-10" 
                            :class="{'position-relative z-index-1042':selected_room_rate.id == room_rate.id && type =='room_rate_add'}" 
                            @click="onBack('room_rate_add',room_rate)">{{$t('hotel.book-now')}} <i class="simple-icon-arrow-up position-relative" v-if="selected_room_rate.id == room_rate.id && type =='room_rate_add'" style="top: 2px;"></i><i class="simple-icon-arrow-down position-relative" v-else style="top: 2px;"></i>
                          </button>
                        </template>
                        <button type="button" class="button-disabled border-none px-3 py-2 rounded-4 text-center" v-else>
                          <p class="mb-0 body-2-2 font-semibold text-disabled text-12">{{$t("hotel.sold-out")}}</p>
                        </button>
                      </template>
                    </template>
                    <template v-else>
                      <button :id="`btn-not-available-${room_rate.id}`" type="button" class="button-disabled border-none px-3 py-2 rounded-4 text-center d-flex align-items-center ml-auto">
                        <p class="mb-0 body-2-2 font-semibold text-disabled text-12">Not Available</p><i class="simple-icon-question ml-2 text-disabled"></i>
                      </button>
                      <b-tooltip :target="`btn-not-available-${room_rate.id}`" triggers="hover" placement="bottom">
                        <div class="p-2" v-html="printNotAvailableRoomMessage(room_rate)">
                        </div>
                      </b-tooltip>
                    </template>
                  </div>

                  <!-- BUTTON RATE DETAIL -->
                  <p v-if="!getMerchant().search_room_is_show_room_rate_detail" class="mb-0 body-3-1 d-table ml-auto cursor-pointer text-green border-bottom-green"
                  @click="onBack('room_rate_detail',room_rate);$postLog('SEARCH','','Clicked Room Rate Detail');hitGoogleAnalytics('room_rate_detail', room_rate)">Rate Detail
                  </p>
                </div>
                <transition name="fade">        
                  <div class="position-absolute bg-white border mt-2 rooms-guest rounded-4 z-index-1038" style="right: -15px;width: 125px;box-shadow: 0px 0px 20px 2px #0000001f" v-if="selected_room_rate.id == room_rate.id && type =='room_rate_add'">

                  	<template v-for="n in $roomAvbl(room_rate.room_type.id,room_rate.id,true)">
                      <p v-if="n < 6" :class="{'text-green': checkIfRoomRateSelected(room_rate.id) == n}" class="mb-0 border-bottom body-2-2 text-14 font-semibold py-2 cursor-pointer text-center hover position-relative" @click="addRoomRate(n,room_rate)">
                        {{n}} <span v-if="n > 1">{{$t('hotel.unit-type.'+data.type+'.units')}}</span><span v-else>{{$t('hotel.unit-type.'+data.type+'.unit')}}</span> 
                        <i v-if="checkIfRoomRateSelected(room_rate.id) == n" style="left:12px;top:12px;" class="text-green simple-icon-check position-absolute"></i>
                      </p>
                    	<p v-else class="mb-0 border-bottom body-2-2 text-14 font-semibold py-2 cursor-pointer text-center hover" @click="onBack('more_room',room_rate)">{{$t('hotel.more-rooms')}}</p>
                  	</template>
                  </div>
                </transition>
              </div>
              <div class="col-12 mt-3" v-if="$showRoomPriceDecoy(room_rate.dates)">
                <RoomPriceDecoy :room-rate="room_rate" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="data.room_rate.length > 5">
        <div class="position-relative" style="top: 10px;">
          <div class="rounded-4 text-center border-black cursor-pointer bg-white py-2 mt-2" v-if="rates_more" @click="toggleShowMoreRates(true,data.room_rate.length)">
            <p class="mb-0 body-2-2 font-semibold text-14">{{$t('hotel.show-more-rates')}}</p>
          </div>
          <div class="rounded-4 text-center border-black cursor-pointer bg-white py-2 mt-2" v-else @click="toggleShowMoreRates(false,data.room_rate.length)">
            <p class="mb-0 body-2-2 font-semibold text-14">{{$t('hotel.show-less')}}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
	import Flickity from 'vue-flickity';
	import {formatCurrency} from '@/utils/index.js'
	import {mapGetters,mapMutations} from 'vuex'
  import moment from 'moment';
  import RoomPriceDecoy from '../RoomPriceDecoy.vue';
  import { trackEvent } from '../../../../utils/analytics';
  import roomRateDetailInline from '@/components/hotel/be/mobile/roomRateDetailInline';

	export default{
    props: {
      data:{
        type: Object,
        default: () => {}
      },
      header_scroll:{
        type: Boolean,
        default: false
      },
      selected_room_rate:{
        type: Object,
        default: () => {}
      },
      type:{
        type: String,
        default: ""
      },
      type_index:{
        type: Number,
        default: -1
      },
      rt_hightlight_index:{
        type: Number,
        default: -1
      },
      type_avlb:{
        type: Number,
        default: 0
      },
      roomRateHighlight:{
        type: Object,
        default: () => {}
      },
      designType:{
        type: String,
        default: "OLD"
      }
    },
		components:{
			Flickity,
      RoomPriceDecoy,
      roomRateDetailInline
		},
		data(){
			return{
				flickityOptionsRoom:{
					initialIndex: 0,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: false,
          wrapAround: true,
				},
        length_more: 5,
        rates_more: true,
        action_success:{
          show: false,
          message: '',
          timer: 0
        }
			}
		},
    computed:{
      detail_parent_text(){
        let display = 'Detail Room'
        if(this.getBeSortBy() == 'promotion'){
          display = 'Detail Promotion'
        }else if(this.getBeSortBy() == 'packages'){
          display = 'Detail Packages'
        }
        return display
      },
      show_success(){
        return this.action_success.show
      },
      promo_left(){
        let time_end = moment().hour(23).minute(59).second(59)
        let time_now = moment()
        let timer = moment.duration(moment(time_end).diff(moment(time_now)))
        let return_data = {
          h: timer.hours() > 10 ? timer.hours() : '0'+timer.hours(),
          m: timer.minutes() > 10 ? timer.minutes() : '0'+timer.minutes()
        }
        return return_data
      },
      room_type_url(){
        var full_url = `${window.location.origin}/${this.getMerchant().code}/hotel-direct-detail/room_type/room_type/${this.data.id}`;
        return full_url
      },
      facilityHighlight(){
        if(this.$isEmpty(this.data) && this.$isEmpty(this.data.facility)) return [];

        const hightlight = this.data.facility.filter(f => this.$isNotEmptyV2(f.is_highlight) && f.is_highlight);

        if(this.$isEmpty(hightlight)) return this.data.facility.slice(0, 5);

        return hightlight;
      }
    },
    watch:{
      show_success(){
        if (this.action_success.show) {
          let looping = setInterval(() => {
            if (this.action_success.timer > 0) {
              this.action_success.timer--
            }else if(this.action_success.timer == 0){
              this.action_success.show = false
              this.action_success.message = ''
              clearInterval(looping)
            }
          },1000) 
        }
      }
    },
		methods:{
			...mapGetters(['getBeSortBy','getBeCartRoom','getBeRoomSubTotal','getBeRoomAvbl','getMerchant','getBeFilter','getCurrentLanguage']),
      ...mapMutations(['BeManipulateRoomRate','changeBeRoomAvbl','BeManipulateRoomRateGuest','beRemoveRoomRate']),
      printTotalNight(dates){
        const totalNight = dates.length
        const unit = this.$t(`hotel.unit-type.${this.data.type}.per-unit`);
        return `${unit} for ${totalNight} ${this.$pluralWord(totalNight, 'night')}`
      },
			formatCurrency(value){
        return formatCurrency(value);
      },
      printRoomLeft(qty){
        if(this.getCurrentLanguage() == 'en' && qty == 1){
          return `${qty} ${this.$t('hotel.unit-type.'+this.data.type+'.unit')} left`
        }else{
          return `${qty} ${this.$t('hotel.unit-type.'+this.data.type+'.units')} left`
        }
      },
      showRoomLeft(rt_id,rr_id){
        let indicator = this.getMerchant().room_availability_max_show
        let room_left = this.$roomAvbl(rt_id,rr_id)
        let is_not_show = indicator == 0
        let is_show_all = indicator == null
        let show_limited = room_left <= indicator

        if(is_not_show || room_left == 0) return false
        else if(is_show_all || show_limited) return true
      },
      checkRoomRateHihglight(roomRateIndex){
        let validRoomType = this.roomRateHighlight.roomTypeIndex === this.type_index;
        let validRoomRate = this.roomRateHighlight.roomRateIndex === roomRateIndex;
        return validRoomType && validRoomRate;
      },  
      checkRoomRateDetailInline(roomRateIndex, roomRate){
        const isDetailShown = this.show_rate_breakdown === roomRate.id
        const isDataEmpty = this.$isEmpty(roomRate.description_room_rate) && this.$isEmpty(roomRate.description_promotion) && this.$isEmpty(roomRate.rate.inclusion);        
        if(isDetailShown || isDataEmpty) return false

        const isHightlight = this.checkRoomRateHihglight(roomRateIndex);
        const isRoomRateAloneAndAvailable = this.data.room_rate.length == 1 && this.type_avlb > 0;
        const isBookable = roomRate.bookable;
        if(isBookable && (isHightlight || isRoomRateAloneAndAvailable)) return true;

        return false;
      },
      printNotAvailableRoomMessage(roomRate){
        if(!roomRate) return '';
        
        if(roomRate.stop_sell) return 'Sorry, the room you selected is unavailable for booking on the chosen dates.';

        let { check_in, check_out } = this.getBeFilter().date
        
        if(roomRate.closed_to_arrival){
          const checkinDate = this.$formatDate(check_in);
          return `Sorry, we cannot accept new arrivals for check-in on <b>${checkinDate}</b>. Please choose a different check-in date.`;
        }
        
        if(roomRate.closed_to_departure){
          const checkoutDate = this.$formatDate(check_out);
          return `Sorry, check-out on <b>${checkoutDate}</b> is not available. Please adjust your stay by extending or shortening your booking.`;
        }

        const totalNightStay = this.$countDays(check_in, check_out);
        
        if(totalNightStay < roomRate.min_nights) return `Sorry, the room requires a minimum stay of <b>${roomRate.min_nights} ${this.$pluralWord(roomRate.min_nights, 'night')}</b>. Please extend your stay to meet the requirement.`;
        
        if(totalNightStay > roomRate.max_nights) return `Sorry, the maximum stay for this room is <b>${roomRate.max_nights} ${this.$pluralWord(roomRate.max_nights, 'night')}</b>. Please shorten your booking to fit within the allowed stay.`;
        
      },
      checkDiscount(data){
        let total_promo_price = 0

        data.forEach(date=>{
          if(date.promo_combine != null){
            let promo_valid = date.promo_combine.promotion_list.filter(x=>x.promotion_type != 'REMAINING_OCCUPANCY' && x.is_apply == true)
            if(promo_valid.length > 0){
              total_promo_price += date.promo_combine.total_promotion_price
            }
          }
        })

        if(total_promo_price < 0){
          return true
        }else{
          return false
        }
      },
      getTotalPriceFromDate(data,return_data,calTaxes = false){
        const showTax = this.getMerchant().search_room_is_show_tax_fee_note
        let total = 0;
        let totalTaxes = 0;
        data.forEach(date=>{
          total += date[return_data];
          totalTaxes += date.taxes;
        })
        if(!showTax && calTaxes) total -= totalTaxes
        return total
      },
			bedCounter(bed){
				let display = ''
				for(let i = 0; i < bed.length; i++){
					if((i+1) == bed.length){
            display += (bed[i].qty+' '+bed[i].name)
          }else{
            display += ((bed[i].qty+' '+bed[i].name)+', ')
          }
				}
				return display
			},
			percentCounter(counter,base){
				let display = ((base-counter)*100)/base
				return  +parseFloat(display).toFixed(2)
			},
			onBack(type,data){
        this.$emit(type,data)
			},
      hitGoogleAnalytics(event, data = null){
        if(this.getMerchant().google_analytics_id != null){
          if(this.getMerchant().google_analytics_id != ''){
            this.$gtag('event',event, { method: 'Google' })
          }
        }
        if(event === 'room_rate_detail') trackEvent('view_item', data);
      },
			parsingPromotionTypeText(data){
				if(data == 'PROMO_CODE'){
					return 'Promo Code'
				}else if(data == 'REGION'){
					return 'Region'
				}else if(data == 'DEVICE'){
					return 'Device'
				}else if(data == 'MULTI_NIGHT'){
					return 'Multi Night'
				}else if(data == 'REMAINING_OCCUPANCY'){
					return 'Remaining Occupancy'
				}else if(data == 'EARLY_BIRD'){
					return 'Earlybird'
				}else if(data == 'LAST_MINUTE_DEAL'){
					return 'Last Minute Deal'
				}else if(data == 'SPECIAL_DEAL'){
					return 'Special Deal'
				}else{
					return data
				}
			},
      // PROMO COMBINATION
			promotionCounter(data){
        let promotion = []
        for(let i = 0; i < data.length; i++){
          if(data[i].promo_combine != null){
            data[i].promo_combine.promotion_list.forEach((item,index)=>{
              let validate = {
                price: item.promotion_price < 0,
                not_ro: item.promotion_type != 'REMAINING_OCCUPANCY',
                is_apply: item.is_apply
              }
              if(validate.price && validate.not_ro && validate.is_apply){
                if(promotion.length == 0){
                  promotion.push({
                    id: item.id,
                    name: item.name
                  })
                }else{
                  let record = promotion.findIndex(x=>x.id == item.id)
                  if(record == -1){
                    promotion.push({
                      id: item.id,
                      name: item.name
                    })
                  }
                }
              }
            })
          }
        }

        let display = ''
        if(promotion.length == 1){
          display = promotion[0].name
        }else if(promotion.length > 1){
          display = promotion[promotion.length-1].name+' and '+(promotion.length-1)+' Other'
        }
        return display
      },
//       promotionCounter(data){
//         let promotion = []
//         for(let i = 0; i < data.length; i++){
//           if(data[i].promotion != null){
//             if(data[i].promotion_price < 0 && data[i].promotion.promotion_type != 'REMAINING_OCCUPANCY'){
//               if(promotion.length == 0){
//                 promotion.push({
//                   id: data[i].promotion.id,
//                   name: data[i].promotion.name
//                 })
//               }else{
//                 let record = promotion.findIndex(x=>x.id == data[i].promotion.id)
//                 if(record == -1){
//                   promotion.push({
//                     id: data[i].promotion.id,
//                     name: data[i].promotion.name
//                   })
//                 }
//               }
//             }
//           }
//         }
// 
//         let display = ''
//         if(promotion.length == 1){
//           display = promotion[0].name
//         }else if(promotion.length > 1){
//           display = promotion[0].name+' and '+(promotion.length-1)+' Other'
//         }
//         return display
//       },
      promotionTimeChecker(data){
        let today = moment().format('YYYY-MM-DD')
        let total_promo_exp_today = []
        data.forEach(date=>{
          if(date.promo_combine != null){
            let promo_valid = date.promo_combine.promotion_list.filter(x=>x.promotion_type != 'REMAINING_OCCUPANCY' && x.is_apply == true)
            promo_valid.forEach(promo_item=>{
              if(promo_item.is_use_custom_sale_stay_date && today == promo_item.sale_date[0].end_date){
                total_promo_exp_today.push(promo_item)
              }
            })
          }
        })
        return total_promo_exp_today.length > 0 ? true : false
      },
      roomVisible(avlb){
        return (avlb < 5) ? avlb : 6
      },
      addToCart(data,n){
        if(!n.is_limit){
          this.addRoomRate(n.counter,data)
        }
      },
      updateRoomTypeAvailability(qty, currentRoomRate, action){
        const { 
          id: rr_id, 
          room_type: { id, is_virtual, availability_affected } 
        } = currentRoomRate
        let availabilityParams = { 
          id, 
          rr_id, 
          is_virtual, 
          availability_affected, 
          action,
          qty 
        }
        this.changeBeRoomAvbl(availabilityParams);
      },
      generateRemainingGuestFilter(){
        const GUEST_TYPE = ['adult','child','infant'];

        let remainingGuestFilter = this.$deepCopy(this.getBeFilter().guest)
        this.getBeCartRoom().forEach(savedRoomRate => {
          savedRoomRate.guest.forEach(savedRoomRateGuest => {
            const { included, extra } = savedRoomRateGuest;
            
            const savedGuestsPerRoomRate = GUEST_TYPE.reduce((acc, key) => {
              acc[key] = included[key] + extra[key];
              return acc;
            }, {});

            GUEST_TYPE.forEach(guest => {
              if(remainingGuestFilter[guest] > 0){
                remainingGuestFilter[guest] -= savedGuestsPerRoomRate[guest]
              } else {
                remainingGuestFilter[guest] = 0
              } 
            })
          });
        })
        return remainingGuestFilter
      },
      includeGuestParamsIfZeroTotal(guest_included, roomConfig){
        let guestIncluded = { adult: 0, child: 0, infant: 0 }
        const currentGuestFilter = this.$deepCopy(this.getBeFilter().guest)

        const { use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant } = roomConfig
        
        if(use_max_guest_by_pax){
          guestIncluded.adult = Math.min(guest_included, max_guest_adult);

          let remainingPax = guest_included - guestIncluded.adult;

          if (currentGuestFilter.child > 0 && remainingPax > 0) {
            guestIncluded.child = Math.min(remainingPax, max_guest_children);
            remainingPax -= guestIncluded.child;
          }

          if (currentGuestFilter.infant > 0 && remainingPax > 0) {
            guestIncluded.infant = Math.min(remainingPax, max_guest_infant);
          }
        }else{
          if(currentGuestFilter.adult > guest_included){
            guestIncluded = { adult: guest_included, child: 0, infant: 0 }
          }else{
            guestIncluded.adult = currentGuestFilter.adult
            const remainingGuestIncludedAfterAdult = guest_included - currentGuestFilter.adult
        
            if(remainingGuestIncludedAfterAdult > 0){
              
              if(currentGuestFilter.child > remainingGuestIncludedAfterAdult){
                guestIncluded.child = remainingGuestIncludedAfterAdult
              }else{
                guestIncluded.child = currentGuestFilter.child
                const { adult, child } = guestIncluded
                const remainingGuestIncludedAfterAdultChild = guest_included - (adult + child)
                const isInfantExist = currentGuestFilter.infant > remainingGuestIncludedAfterAdultChild
                if(remainingGuestIncludedAfterAdultChild > 0 && isInfantExist){
                  guestIncluded.infant = remainingGuestIncludedAfterAdultChild
                }
              }
            }
          }
        }
        return guestIncluded;
      },
      allocateGuestPerRoom(guestParamsIncluded, remainingGuestFilter, guest_included){
        let includedGuest = guestParamsIncluded
        let remainingGuest = remainingGuestFilter
        
        const GUEST_TYPE = ['adult','child','infant'];
        GUEST_TYPE.forEach(guest => {
          let totalGuestIncludedPerRoom = Object.values(includedGuest).reduce((sum, value) => sum + value, 0);
          if(remainingGuest[guest] > 0 && totalGuestIncludedPerRoom < guest_included){
            let remainingPaxPerRoom = guest_included - totalGuestIncludedPerRoom
            if(remainingGuest[guest] > guest_included){
              includedGuest[guest] = remainingPaxPerRoom
              remainingGuest[guest] -= remainingPaxPerRoom
            }else{
              includedGuest[guest] = remainingPaxPerRoom > remainingGuest[guest] ? remainingGuest[guest] : remainingPaxPerRoom
              remainingGuest[guest] -= includedGuest[guest]
            }
          }
        });
        return { includedGuest, remainingGuest }
      },
      allocateSpecificGuestPerRoom(remainingGuests, maxGuests, includedGuests){
        let allocatedGuests = { adult: 0, child: 0, infant: 0 };
        let remainingIncluded = includedGuests;

        const allocate = (type) => {
          if (remainingIncluded <= 0) return;
          const count = Math.min(remainingGuests[type], maxGuests[type], remainingIncluded);
          allocatedGuests[type] = count;
          remainingGuests[type] -= count;
          remainingIncluded -= count;
        }

        allocate('adult');
        allocate('child');
        allocate('infant');

        return allocatedGuests;
      },
      generateRoomRateGuestParam(selectedRoomRateQty, currentRoomRate){
        let finalCountGuests = []
        
        const { rate, room_type } = currentRoomRate
        const {
          use_max_guest_by_pax = false,
          max_guests = null,
          max_guest_adult = 0,
          max_guest_children = 0,
          max_guest_infant = 0,
        } = rate.max_guests ? rate : room_type;
        const roomConfig = {use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant}

        const GUEST_TYPE = ['adult','child','infant'];
        let remainingGuestFilter = this.generateRemainingGuestFilter()
        const totalRemainingGuestFilter = Object.values(remainingGuestFilter).reduce((sum, value) => sum + value, 0)

        for (let i = 0; i < selectedRoomRateQty; i++) {
          let guestParams = {
            included: { adult: 0, child: 0, infant: 0 },
            extra: { adult: 0, child: 0, infant: 0 },
          }
          
          if(totalRemainingGuestFilter === 0){
            guestParams.included = this.includeGuestParamsIfZeroTotal(rate.guest_included, roomConfig)
            finalCountGuests.push(guestParams);
          }else{
            
            // Calculate guest included
            if(use_max_guest_by_pax){
              const maxGuests = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant };
              guestParams.included = this.allocateSpecificGuestPerRoom(remainingGuestFilter, maxGuests, rate.guest_included);
            }else{
              if(totalRemainingGuestFilter > rate.guest_included){
                const { includedGuest, remainingGuest } = this.allocateGuestPerRoom(guestParams.included, remainingGuestFilter, rate.guest_included)
                guestParams.included = includedGuest
                remainingGuestFilter = remainingGuest
              }else{
                guestParams.included = remainingGuestFilter
                remainingGuestFilter = { adult: 0, child: 0, infant: 0 }
              }
            }

            finalCountGuests.push(guestParams);

            // Calculate extra guest
            const isLastLooper = i+1 === selectedRoomRateQty;
            if(isLastLooper){
              let notIncludedGuest = Object.values(remainingGuestFilter).reduce((sum, value) => sum + value, 0)

              if(notIncludedGuest > 0){
                for(let j = 0; j < selectedRoomRateQty; j++){
                  let guestPerQtyRoom = finalCountGuests[j]
                  if(use_max_guest_by_pax){
                    const maxGuestsPerType = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant };
                    const guestIncluded = guestPerQtyRoom.included
                    
                    for (const type of GUEST_TYPE){
                      let remainingPaxForExtra = maxGuestsPerType[type] - guestIncluded[type];
                      if(remainingPaxForExtra <= 0) continue;

                      const totalCurrentGuest = Object.values(finalCountGuests[j]).flatMap(Object.values).reduce((a, b) => a + b, 0);
                      if(max_guests <= totalCurrentGuest) continue;

                      const remainingFromMaxGuests = max_guests - totalCurrentGuest;
                      const extraFinal = Math.min(remainingPaxForExtra, remainingGuestFilter[type], remainingFromMaxGuests);
                      finalCountGuests[j].extra[type] = extraFinal;
                      remainingGuestFilter[type] -= extraFinal;
                    }

                  }else{
                    let totalGuestIncludedPerRoom = Object.values(guestPerQtyRoom.included).reduce((sum, value) => sum + value, 0);  
                    let remainingPaxForExtra = max_guests-totalGuestIncludedPerRoom

                    for (const type of GUEST_TYPE) {
                      if (remainingGuestFilter[type] > 0) {
                        const extraFinal = Math.min(remainingPaxForExtra, remainingGuestFilter[type]);
                        finalCountGuests[j].extra[type] = extraFinal;
                        remainingGuestFilter[type] -= extraFinal;
                      }
                      
                    }
                  }
                }
              }
            }
          }
        }

        return finalCountGuests;
      },
      addRoomRate(qty, selectedRoomRate){
        const validQty = parseInt(qty);
        const currentRoomRate = this.$deepCopy(selectedRoomRate)
        
        const savedRoom = this.$deepCopy(this.getBeCartRoom())
        let savedRoomRateIndex = savedRoom.findIndex(savedRoomRate=>savedRoomRate.room_rate.id === currentRoomRate.id)
        
        if(savedRoomRateIndex != -1){
          this.beRemoveRoomRate(currentRoomRate.id);
          this.updateRoomTypeAvailability(savedRoom[savedRoomRateIndex].qty, currentRoomRate, 'inc')
          setTimeout(()=>{
            this.addRoomRate(validQty, currentRoomRate)
          },100)
        } else {
          this.updateRoomTypeAvailability(validQty, currentRoomRate, 'dec')
          const roomRateParam = {
            room_rate: currentRoomRate,
            qty: validQty,
            guest: this.generateRoomRateGuestParam(validQty, currentRoomRate)
          }
          this.BeManipulateRoomRate(roomRateParam)
          setTimeout(()=>{
            this.updatePriceAccordingToPax(currentRoomRate.id, roomRateParam.guest)
          },100)
          this.onBack("room_rate_add",currentRoomRate)
          setTimeout(()=>{
            this.onBack("room_rate_add",'')
          },200)

          this.$sendEventMetaConversionsAPI('AddToWishlist', {
            id: currentRoomRate.id_ori,
            name: currentRoomRate.name,
            dates: currentRoomRate.dates,
            qty: validQty
          });
          trackEvent("add_to_cart", {roomRate: currentRoomRate, qty: validQty})
        }
      },
      updatePriceAccordingToPax(room_rate_id,guests){
        console.log("guests :", guests)
        let guest_params = { 
            id: room_rate_id, 
            guest: {
              included: [],
              extra: []
            } 
          }

          guests.forEach((item,index)=>{
            guest_params.guest.included.push(item.included)
            guest_params.guest.extra.push(item.extra)
          })
          
        this.BeManipulateRoomRateGuest(guest_params)
      },
      checkIfRoomRateSelected(id){
        let record = this.getBeCartRoom().findIndex(x=>x.room_rate.id == id)
        if(record != -1){
          return this.getBeCartRoom()[record].qty
        }else{
          return 0
        }
      },
      toggleShowMoreRates(type,length){
        if (this.rates_more) {
          this.length_more = length
          this.rates_more = false
        }else{
          this.length_more = 5
          this.rates_more = true
        }
      },
      copyLink(){
        var params = {
          type : (this.getBeSortBy() == 'room_type') ? 'room_type' : 'rate',
          sort_by: this.getBeSortBy()
        } 
        var full_url = window.location.origin+"/"+this.getMerchant().code+'/hotel-direct-detail/'+params.type+'/'+params.sort_by+'/'+this.data.id;
        var input_temp = document.createElement("input");
        input_temp.value = full_url;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.action_success.show = true
        this.action_success.message = 'Link copied!'
        this.action_success.timer = 1
      },
      getQty(id){
        let display = 0
        if(this.getBeCartRoom().length > 0){
          let record = this.getBeCartRoom().findIndex(x=>x.room_rate.id == id)
          if(record != -1){
            display = this.getBeCartRoom()[record].qty
          }
        }else{
          display = 0
        }
        return display
      },
      slideTheSlider(action='next'){
        if(this.$refs.flickity){
          if(action === 'next') this.$refs.flickity.next();
          else this.$refs.flickity.previous();
        }
      }
		}
	}
</script>
<style scoped>
  .wrapper-position{
    top: -90px;
  }
  .wrapper-position.old{
    top: -48px!important;
  }
  .wrapper-position.new{
    top: -20px!important;
  }

  .rooms-guest:after, .rooms-guest:before{
    position: absolute;
    display: inline-block;
    content: "";
    top: -6px;
    left: 56px;
  }

  .rooms-guest:after{
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
    border-left: 7px solid transparent;
  }

  .rooms-guest:before{
    top: -7px;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-bottom: 7px solid #ccc;
  }
  .h-img-nearby{
    border-radius: 4px 4px 0px 0px;
  }
  @media screen and (min-width: 576px){
    .h-img-nearby{
      border-radius: 4px;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/hotel/be/mobile/room.vue